<template>
  <section class="enterprise-value">
    <div class="container">
      <h2 class="section-title">{{ $t('enterprise.valuePropositionTitle') }}</h2>
      
      <div class="value-grid">
        <div class="value-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('enterprise.talentAccuracy') }}</h3>
          <p>{{ $t('enterprise.talentAccuracyDesc') }}</p>
        </div>

        <div class="value-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('enterprise.riskMitigation') }}</h3>
          <p>{{ $t('enterprise.riskMitigationDesc') }}</p>
        </div>

        <div class="value-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M3 12h18M3 6h18M3 18h18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('enterprise.scalingCapacity') }}</h3>
          <p>{{ $t('enterprise.scalingCapacityDesc') }}</p>
        </div>

        <div class="value-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ $t('enterprise.ctaSubtitle') }}</h3>
          <p>{{ $t('enterprise.ctaSubtitle') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EnterpriseValueProposition'
}
</script>

<style scoped>
.enterprise-value {
  padding: 5rem 2rem;
  background: 
    radial-gradient(circle at 100% 0%, rgba(0, 217, 255, 0.08) 0, transparent 50%),
    radial-gradient(circle at 0% 100%, rgba(138, 43, 226, 0.08) 0, transparent 50%),
    #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 3rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.value-card {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.value-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.1), rgba(138, 43, 226, 0.1));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.value-card:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.value-card:hover::before {
  opacity: 1;
}

.card-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 1rem;
  color: #00D9FF;
}

.card-icon svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 0 10px rgba(0, 217, 255, 0.3));
}

.value-card h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 0.75rem;
  position: relative;
  z-index: 1;
}

.value-card p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
  line-height: 1.6;
  position: relative;
  z-index: 1;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .enterprise-value {
    padding: 3rem 1.5rem;
  }
}
</style>
